<button
  [cdkMenuTriggerFor]="menu"
  type="button"
  id="user-menu-button"
  class="focus:ring-primary-600 flex rounded-full bg-white text-sm focus:ring-2 focus:ring-offset-2 focus:outline-hidden"
>
  <span class="sr-only">Open user menu</span>
  <wma-avatar
    [size]="size()"
    [src]="user().picture"
    [initials]="(user().name ?? '').trim()[0]"
    alt=""
  />
</button>

<ng-template #menu>
  @let menuItemClass =
    'group flex w-full items-center gap-2 rounded-lg px-2 py-2 text-start text-sm font-medium text-gray-700 hover:bg-gray-100 hover:text-gray-900';
  @let iconClass = 'size-4 shrink-0 text-gray-500 transition group-hover:text-gray-700';
  <div
    aria-labelledby="user-menu-button"
    animate.enter="animate-fade-scale-in"
    animate.leave="animate-fade-scale-out"
    class="z-0 mt-2 w-56 space-y-1 rounded-xl bg-white p-1 shadow-lg ring-1 ring-black/5 focus:outline-hidden"
    [attr.dir]="isRtl() ? 'rtl' : 'ltr'"
    cdkMenu
  >
    <div
      class="text-primary-900 truncate overflow-hidden border-b border-gray-100 px-3 py-2 text-sm font-medium"
    >
      {{ user().name }}
    </div>
    <button type="button" cdkMenuItem [cdkMenuTriggerFor]="languageMenu" [class]="menuItemClass">
      <span class="flex min-w-0 flex-1 items-center gap-2">
        <wma-icon [class]="iconClass" name="globe-alt" />
        <span class="min-w-0 flex-1 truncate text-start">
          {{ 'COMMON.LANGUAGE' | translate }}
        </span>
      </span>
      <span class="flex shrink-0 items-center gap-2">
        <span class="max-w-20 truncate text-end text-xs text-gray-500">
          {{ getCurrentLanguageLabel() | translate }}
        </span>
        <wma-icon
          class="size-4 shrink-0 text-gray-400 transition group-hover:text-gray-600"
          [class.rotate-180]="isRtl()"
          name="chevron-right"
        />
      </span>
    </button>
    @if (showDocsLink()) {
      <a cdkMenuItem routerLink="/docs" [class]="menuItemClass">
        <wma-icon [class]="iconClass" name="book-open" />
        <span class="min-w-0 flex-1 truncate">{{ 'COMMON.DOCUMENTATION' | translate }}</span>
      </a>
    }
    <div class="border-t border-gray-100 pt-1">
      <button type="button" cdkMenuItem (click)="emitLogout()" [class]="menuItemClass">
        <wma-icon
          [class]="iconClass"
          [class.rotate-180]="isRtl()"
          name="arrow-left-start-on-rectangle"
        />
        <span class="min-w-0 flex-1 truncate">{{ 'COMMON.LOGOUT' | translate }}</span>
      </button>
    </div>
  </div>
</ng-template>

<ng-template #languageMenu>
  <div
    class="z-0 mt-2 w-52 space-y-0.5 rounded-xl bg-white p-1 shadow-lg ring-1 ring-black/5 focus:outline-hidden"
    cdkMenu
    [attr.dir]="isRtl() ? 'rtl' : 'ltr'"
    animate.enter="animate-fade-scale-in"
    animate.leave="animate-fade-scale-out"
  >
    @for (locale of locales; track locale.code) {
      <button
        type="button"
        cdkMenuItem
        (click)="switchLocale(locale.code)"
        class="flex w-full items-center rounded-lg px-2 py-2 text-start text-sm font-medium text-gray-700 hover:bg-gray-100 hover:text-gray-900"
        [class.bg-primary-50]="locale.code === currentLocale()"
        [class.text-primary-700]="locale.code === currentLocale()"
      >
        <span class="flex-1 truncate">{{ locale.label | translate }}</span>
        @if (locale.code === currentLocale()) {
          <wma-icon class="text-primary-600 size-4 shrink-0" name="check-circle" />
        }
      </button>
    }
  </div>
</ng-template>
